export const APPLE_PLATFORM = 'apple';

export const extractFileName = (contentDisposition: string) => {
  if (contentDisposition) {
    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
    const filenameStarRegex = /filename\*=UTF-8''([^;\n]*)/;

    // Tries to get name from the key 'filename*'
    const starMatch = contentDisposition.match(filenameStarRegex);
    if (starMatch && starMatch[1]) {
      return decodeURIComponent(starMatch[1]);
    }

    // Tries to get name from the key 'filename'
    const match = contentDisposition.match(filenameRegex);
    if (match && match[1]) {
      return match[1].replace(/^["']|["']$/g, '');
    }
  }

  return '';
};
